export enum ICD10ValueSets {
  Clinical = "http://hl7.org/fhir/sid/icd-10-cm/vs",
}
